import { TPageMapValue } from 'models/common.model'
import { lazy } from 'react'
import { PageIdWoofzK9Bl } from './pages'

type TIdToPageMapWoofzK9Bl = Record<PageIdWoofzK9Bl, TPageMapValue>

export const ID_TO_PAGE_MAP_WOOFZ_K9_BL: TIdToPageMapWoofzK9Bl = {
  [PageIdWoofzK9Bl.DOG_AGE_K9_BL]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_k9_bl/pages/questions/DogAge').then((m) => ({
        default: m.DogAge,
      })),
    ),
    preload: () => import('nove8/cohorts/woofz_k9_bl/pages/questions/DogAge'),
  },
  [PageIdWoofzK9Bl.DOG_SEX_K9_BL]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_k9_bl/pages/questions/SexQuestion').then(
        (m) => ({
          default: m.SexQuestion,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_k9_bl/pages/questions/SexQuestion'),
  },
  [PageIdWoofzK9Bl.DOG_BREED_K9_BL]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_k9_bl/pages/questions/dog-breed/DogBreedQuestion'
      ).then((m) => ({
        default: m.DogBreedQuestion,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/woofz_k9_bl/pages/questions/dog-breed/DogBreedQuestion'
      ),
  },
  [PageIdWoofzK9Bl.DOG_BREED_ID_K9_BL]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_k9_bl/pages/questions/dog-breed/breed-id/BreedPhotoScreenK9'
      ).then((m) => ({
        default: m.BreedPhotoScreenK9,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/woofz_k9_bl/pages/questions/dog-breed/breed-id/BreedPhotoScreenK9'
      ),
  },
  [PageIdWoofzK9Bl.URGE_K9_BL]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_k9_bl/pages/urge/UrgePage').then((m) => ({
        default: m.UrgePage,
      })),
    ),
    preload: () => import('nove8/cohorts/woofz_k9_bl/pages/urge/UrgePage'),
  },
  [PageIdWoofzK9Bl.CHALLENGES_K9_BL]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_k9_bl/pages/questions/GoalsQuestionK9').then(
        (m) => ({
          default: m.GoalsQuestionK9,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_k9_bl/pages/questions/GoalsQuestionK9'),
  },
  [PageIdWoofzK9Bl.URGE_1_K9_BL]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_k9_bl/pages/urge/Urge1Page').then((m) => ({
        default: m.Urge1Page,
      })),
    ),
    preload: () => import('nove8/cohorts/woofz_k9_bl/pages/urge/Urge1Page'),
  },
  [PageIdWoofzK9Bl.LEASH_PULLING_K9_BL]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_k9_bl/pages/questions/LeashPulling').then(
        (m) => ({
          default: m.LeashPulling,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_k9_bl/pages/questions/LeashPulling'),
  },
  [PageIdWoofzK9Bl.URGE_LEASH_K9_BL]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_k9_bl/pages/urge/UrgeLeashPage').then(
        (m) => ({
          default: m.UrgeLeashPage,
        }),
      ),
    ),
    preload: () => import('nove8/cohorts/woofz_k9_bl/pages/urge/UrgeLeashPage'),
  },
  [PageIdWoofzK9Bl.DURING_WALK_K9_BL]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_k9_bl/pages/questions/DuringWalkQuestion'
      ).then((m) => ({
        default: m.DuringWalkQuestion,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_k9_bl/pages/questions/DuringWalkQuestion'),
  },
  [PageIdWoofzK9Bl.URGE_NOT_ALONE_K9_BL]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_k9_bl/pages/urge/UrgeNotAlone').then((m) => ({
        default: m.UrgeNotAlonePage,
      })),
    ),
    preload: () => import('nove8/cohorts/woofz_k9_bl/pages/urge/UrgeNotAlone'),
  },
  [PageIdWoofzK9Bl.AGRESSIVE_BEHAVIOR_K9_BL]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_k9_bl/pages/questions/AgressiveBehavior'
      ).then((m) => ({
        default: m.AgressiveBehavior,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_k9_bl/pages/questions/AgressiveBehavior'),
  },
  [PageIdWoofzK9Bl.TRIGGERS_K9_BL]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_k9_bl/pages/questions/TriggersQuestion').then(
        (m) => ({
          default: m.TriggersQuestion,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_k9_bl/pages/questions/TriggersQuestion'),
  },
  [PageIdWoofzK9Bl.URGE_2_K9_BL]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_k9_bl/pages/urge/UrgePageVariant2').then(
        (m) => ({
          default: m.UrgePageVariant2,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_k9_bl/pages/urge/UrgePageVariant2'),
  },
  [PageIdWoofzK9Bl.BEHAVIOR_ISSUES_K9_BL]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_k9_bl/pages/questions/BehaviorIssues').then(
        (m) => ({
          default: m.BehaviorIssues,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_k9_bl/pages/questions/BehaviorIssues'),
  },
  [PageIdWoofzK9Bl.DOG_ACT_K9_BL]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_k9_bl/pages/questions/DogActQuestion').then(
        (m) => ({
          default: m.DogActQuestion,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_k9_bl/pages/questions/DogActQuestion'),
  },
  [PageIdWoofzK9Bl.DOG_OFF_AT_HOME_K9_BL]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_k9_bl/pages/questions/DogOffAtHome').then(
        (m) => ({
          default: m.DogOffAtHome,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_k9_bl/pages/questions/DogOffAtHome'),
  },
  [PageIdWoofzK9Bl.REWARDS_K9_BL]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_k9_bl/pages/questions/RewardsQuestion').then(
        (m) => ({
          default: m.RewardsQuestion,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_k9_bl/pages/questions/RewardsQuestion'),
  },
  [PageIdWoofzK9Bl.IGNORE_COMMANDS_K9_BL]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_k9_bl/pages/questions/DogIgnoreQuestion'
      ).then((m) => ({
        default: m.DogIgnoreQuestion,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_k9_bl/pages/questions/DogIgnoreQuestion'),
  },
  [PageIdWoofzK9Bl.COMMANDS_61_K9_BL]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_k9_bl/pages/questions/Commands61Question'
      ).then((m) => ({
        default: m.Commands61Question,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_k9_bl/pages/questions/Commands61Question'),
  },
  [PageIdWoofzK9Bl.COMMANDS_62_K9_BL]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_k9_bl/pages/questions/Commands62Question'
      ).then((m) => ({
        default: m.Commands62Question,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_k9_bl/pages/questions/Commands62Question'),
  },
  [PageIdWoofzK9Bl.COMMANDS_63_K9_BL]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_k9_bl/pages/questions/Commands63Question'
      ).then((m) => ({
        default: m.Commands63Question,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_k9_bl/pages/questions/Commands63Question'),
  },
  [PageIdWoofzK9Bl.URGE_3_K9_BL]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_k9_bl/pages/urge/UrgeProgram').then((m) => ({
        default: m.UrgeProgram,
      })),
    ),
    preload: () => import('nove8/cohorts/woofz_k9_bl/pages/urge/UrgeProgram'),
  },
  [PageIdWoofzK9Bl.PREPARE_SCREEN_K9_BL]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_k9_bl/pages/urge/UrgePrepareScreen').then(
        (m) => ({
          default: m.UrgePrepareScreen,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_k9_bl/pages/urge/UrgePrepareScreen'),
  },
  [PageIdWoofzK9Bl.DOG_PROFILE_K9_BL]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_k9_bl/pages/dog-profile/DogProfile').then(
        (m) => ({
          default: m.DogProfile,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_k9_bl/pages/dog-profile/DogProfile'),
  },
  [PageIdWoofzK9Bl.URGE_REVIEWED_K9_BL]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_k9_bl/pages/urge/UrgeReviewed').then((m) => ({
        default: m.UrgeReviewedPage,
      })),
    ),
    preload: () => import('nove8/cohorts/woofz_k9_bl/pages/urge/UrgeReviewed'),
  },
  [PageIdWoofzK9Bl.SOCIAL_SCREEN_K9_BL]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_k9_bl/pages/urge/SocialScreen').then((m) => ({
        default: m.SocialScreenPage,
      })),
    ),
    preload: () => import('nove8/cohorts/woofz_k9_bl/pages/urge/SocialScreen'),
  },
  [PageIdWoofzK9Bl.PREPARE_FLOW_K9_BL]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_k9_bl/pages/prepare-flow/PrepareFlow').then(
        (m) => ({
          default: m.PrepareFlow,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_k9_bl/pages/prepare-flow/PrepareFlow'),
  },
  [PageIdWoofzK9Bl.EMAIL_K9_BL]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_k9_bl/pages/email/Email').then((m) => ({
        default: m.Email,
      })),
    ),
    preload: () => import('nove8/cohorts/woofz_k9_bl/pages/email/Email'),
  },
  [PageIdWoofzK9Bl.NEWSLETTER_URGE_K9_BL]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_k9_bl/pages/email/NewsletterUrge').then(
        (m) => ({
          default: m.NewsletterUrge,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_k9_bl/pages/email/NewsletterUrge'),
  },
  [PageIdWoofzK9Bl.DISCIPLINE_SCREEN_K9_BL]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_k9_bl/pages/urge/DisciplineScreen').then(
        (m) => ({
          default: m.DisciplineScreenPage,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_k9_bl/pages/urge/DisciplineScreen'),
  },
  [PageIdWoofzK9Bl.SCRATCH_SCREEN_K9_BL]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_k9_bl/pages/last-chance-offer/LastChanceOfferScratch'
      ).then((m) => ({
        default: m.LastChanceOfferScratch,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/woofz_k9_bl/pages/last-chance-offer/LastChanceOfferScratch'
      ),
  },
  [PageIdWoofzK9Bl.SUBSCRIPTIONS_K9_BL]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_k9_bl/pages/subscriptions/Subscriptions'
      ).then((m) => ({
        default: m.Subscriptions,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_k9_bl/pages/subscriptions/Subscriptions'),
  },
  [PageIdWoofzK9Bl.CHAT_UPSELL_K9_BL]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_k9_bl/pages/upsell/ChatUpsellComponent').then(
        (m) => ({
          default: m.ChatUpsellComponent,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_k9_bl/pages/upsell/ChatUpsellComponent'),
  },
  [PageIdWoofzK9Bl.UPSELL_K9_BL]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_k9_bl/pages/upsell/Upsell').then((m) => ({
        default: m.Upsell,
      })),
    ),
    preload: () => import('nove8/cohorts/woofz_k9_bl/pages/upsell/Upsell'),
  },
  [PageIdWoofzK9Bl.UPSELL_FEEDING_GUIDE_K9_BL]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_k9_bl/pages/upsell/FeedingGuideUpsell').then(
        (m) => ({
          default: m.FeedingGuideUpsell,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_k9_bl/pages/upsell/FeedingGuideUpsell'),
  },
  [PageIdWoofzK9Bl.UPSELL_EMOTIONAL_SUPPORT_K9_BL]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_k9_bl/pages/upsell/EmotionalSupportUpsell'
      ).then((m) => ({
        default: m.EmotionalSupportUpsell,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_k9_bl/pages/upsell/EmotionalSupportUpsell'),
  },
  [PageIdWoofzK9Bl.DOWNLOAD_K9_BL]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_k9_bl/pages/download-app/DownloadApp').then(
        (m) => ({
          default: m.DownloadApp,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_k9_bl/pages/download-app/DownloadApp'),
  },
  [PageIdWoofzK9Bl.ACCOUNT_K9_BL]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_k9_bl/modules/account/AccountK9Bl').then(
        (m) => ({
          default: m.AccountK9Bl,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_k9_bl/modules/account/AccountK9Bl'),
  },
}
